<template>
  <BaseTableView :head="tableHead">
    <WorkTypeTableItem v-for="item in workTypeGrid" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkTypeTableItem from 'components/setting/workType/WorkTypeTableItem'
export default {
  props: ['workTypeGrid'],
  components: { WorkTypeTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting']['settings-finance']['code'],
        },
        {
          text: this.localStorage.translations.pages['setting-work_type']['tables']['kategoriya'],
        },
        {
          text: this.localStorage.translations.pages['setting-work_type']['tables']['vid-rabot'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-work_type']['tables'][
            'edinitsa-izmereniya'
          ],
          sort: {
            name: 'measure',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'measure'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-work_type']['tables']['tsena'],
          sort: {
            name: 'price',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'price'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
